import { type FC } from 'react'
import { ErrorMessage, Field, useField } from 'formik'
import classNames from 'classnames'
import { type SelectOption, type Values } from '../../SignUpForm.interface'
import FieldLabel from '../FieldLabel/FieldLabel'
import styles from './FormSelect.module.scss'

interface FormSelectProps {
  name: keyof Values;
  label?: string;
  optionalText?: string;
  options: SelectOption[];
  placeholder?: string;
  errorOverride?: boolean;
}

const FormSelect: FC<FormSelectProps> = ({
  name,
  label,
  optionalText,
  options,
  placeholder,
  errorOverride
}) => {
  const [field, meta] = useField(name)
  // Null coalescance isnt what i want here. I want or
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
  const hasErrror = errorOverride || (meta.error && meta.touched)

  return (
    <div className="form-field">
      <label htmlFor={name}>
        {label && <FieldLabel label={label} optional={optionalText} />}
        <Field
          className={classNames(
            styles['form-select__input'],
            {
              [styles['form-input__input-error']]:
              hasErrror
            }
          )}
          aria-invalid={hasErrror}
          as="select"
          id={name}
          name={name}
          value={field?.value ? field.value : '_DEFAULT'}
        >
          {placeholder && (
            <option value="_DEFAULT" disabled>
              {placeholder}
            </option>
          )}
          {options.map((option) => {
            if (!option) return null
            const { id, value, label: optionLabel } = option
            return (
              <option key={id} value={value}>
                {optionLabel}
              </option>
            )
          })}
        </Field>
        <ErrorMessage
          className={styles['form-input__error-message']}
          component="div"
          name={name}
        />
      </label>
    </div>
  )
}

export default FormSelect
